import { Breadcrumbs, ErrorState } from '../../components';
import useDocumentHead from '../../hooks/useDocumentHead';
import { useLang } from '../../i18n';
import { pickPrimaryOffice, useContactsData } from './hooks/useContactsData';
import HeroSection from './sections/HeroSection';
import ChannelsSection from './sections/ChannelsSection';
import FormSection from './sections/FormSection';
import OfficesSection from './sections/OfficesSection';
import './ContactsPage.scss';

export default function ContactsPage() {
  const { t } = useLang();
  const { data, loading, error } = useContactsData();
  const primary = pickPrimaryOffice(data.offices);

  useDocumentHead({
    title: `${t('contacts.title')} — ${t('brand.name')}`,
    description: t('contacts.lead'),
    canonical: 'https://ukam.uz/contacts',
    og: {
      title: t('contacts.h1'),
      description: t('contacts.lead'),
      type: 'website',
      url: 'https://ukam.uz/contacts',
    },
    schemaOrg: [
      {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        url: 'https://ukam.uz/contacts',
        name: t('contacts.title'),
      },
      ...(primary
        ? [
            {
              '@context': 'https://schema.org',
              '@type': 'LocalBusiness',
              name: primary.name || t('brand.name'),
              address: primary.address || undefined,
              telephone: primary.phone || undefined,
              email: primary.email || undefined,
              openingHours: primary.hours || undefined,
              ...(primary.latitude != null && primary.longitude != null
                ? {
                    geo: {
                      '@type': 'GeoCoordinates',
                      latitude: primary.latitude,
                      longitude: primary.longitude,
                    },
                  }
                : {}),
            },
          ]
        : []),
    ],
  });

  if (error && !loading) {
    return (
      <div className="contacts-page contacts-page--error">
        <div className="container">
          <Breadcrumbs items={[{ label: t('brand.name'), href: '/' }, { label: t('contacts.title') }]} />
          <ErrorState title={t('contacts.empty')} />
        </div>
      </div>
    );
  }

  return (
    <div className="contacts-page">
      <div className="container contacts-page__crumbs">
        <Breadcrumbs items={[{ label: t('brand.name'), href: '/' }, { label: t('contacts.title') }]} />
      </div>
      <HeroSection />
      <ChannelsSection office={primary} loading={loading} />
      <FormSection />
      <OfficesSection offices={data.offices} loading={loading} />
    </div>
  );
}
